import { BrandGradients } from '@/lib/brandGradients';

const base = {
  color: 'transparent',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
} as const;

export const gradientTextValentine = { ...base, backgroundImage: BrandGradients.valentine };
export const gradientTextAura = { ...base, backgroundImage: BrandGradients.aura };
export const gradientTextLotus = { ...base, backgroundImage: BrandGradients.lotus };
